"use client";
import { Link } from "@/i18n/routing";
import { useEffect, useRef } from "react";
import { onScroll } from "../../(utils)/scrollBus";

// Le logo est fixe et passerait sur les titres : il se retire quand on descend, revient dès qu'on remonte
function useHideOnScroll() {
  const ref = useRef<HTMLAnchorElement>(null);
  useEffect(() => {
    let last = scrollY;
    let hidden = false;
    return onScroll(() => {
      const y = scrollY;
      const next = y > innerHeight * 0.6 && (y > last + 2 || (hidden && y >= last - 2));
      if (next !== hidden) ref.current?.toggleAttribute("data-hidden", (hidden = next));
      last = y;
    });
  }, []);
  return ref;
}

export default function Logo() {
  const ref = useHideOnScroll();
  return (
    <div className="logowrapper">
      <Link
        href="/"
        passHref
        ref={ref}
        className="hm-logo fixed left-6 top-6 z-[999] h-16 w-16 cursor-pointer lg:left-16 lg:top-8 lg:h-24 lg:w-24"
        aria-label="home"
      >
        <svg
          version="1.1"
          id="Layer_1"
          x="0px"
          y="0px"
          width="100%"
          viewBox="0 0 184 184"
          enableBackground="new 0 0 184 184"
        >
          <path
            fill="#F0EDF2"
            id="logo"
            opacity="1.000000"
            stroke="none"
            d="M 54.9242 139.8796 C 53.5107 140.0489 52.0972 140.2181 50.3244 140.4035 C 48.0345 139.361 46.1041 138.3022 43.9087 137.1258 C 44.4507 134.5907 45.2579 132.1732 46.1191 129.4081 C 47.4487 126.9452 48.7242 124.8298 50.0516 122.3746 C 51.9451 119.1443 53.7868 116.2539 54.9264 114.4653 C 62.3973 98.4434 66 98 67.271 93.5057 C 68.3172 91.6992 69.2966 90.2671 70.3395 88.4955 C 71.6971 86.7143 72.9912 85.2728 74.6546 83.3073 C 84.3636 68.8478 93.751 54.944 102.9999 40.9486 C 104.7121 38.3576 105.8652 35.3971 107.2763 32.6071 C 107.6269 32.6388 107.9774 32.6706 108.8277 32.7924 C 110.0784 33.0835 110.8293 33.2845 111.5803 33.4855 C 111.5803 33.4855 111.6675 33.7312 112.0146 33.914 C 117.454 39.3009 121.1963 44.8416 119.528 52.8232 C 113.7121 80.647 107.7771 108.4632 106.0884 136.9505 C 104.6576 137.1936 103.2269 137.4366 101.4287 137.7349 C 95.7008 136.0474 93.6261 132.2413 93.877 126.7665 C 94.0518 122.954 93.9107 119.1269 93.9107 115.0293 C 88.3542 116.1312 83.0745 117.4615 78.1897 112.5997 C 76.5109 111.1217 75.3075 110.0969 73.1677 108.2744 C 66.8754 119.1754 60.8998 129.5275 54.9242 139.8796"
          />
          <path
            fill="#75102E"
            opacity="1.000000"
            stroke="none"
            d="M106.398102,137.125610 C107.777107,108.463158 113.712135,80.647026 119.527954,52.823212 C121.196281,44.841610 117.454018,39.300934 112.144775,33.907524 C117.040344,31.846319 119.958458,34.875992 122.548424,38.528988 C123.672852,40.114937 124.655968,41.801083 125.915443,43.718651 C125.408195,50.713367 124.688766,57.431152 123.964676,64.569122 C122.590599,71.695595 121.221199,78.401894 119.819099,85.527100 C119.112923,89.331535 118.439445,92.717056 117.541092,96.823578 C116.791130,102.334427 116.266022,107.124268 115.594315,112.292465 C115.258102,115.449005 115.068497,118.227173 114.878891,121.005348 C114.846214,121.437347 114.813530,121.869347 114.769333,122.625984 C114.525772,124.383354 114.293709,125.816086 113.938858,127.905350 C113.646332,129.367859 113.476593,130.173828 113.306854,130.979813 C113.184624,132.661697 113.062401,134.343582 112.936188,136.442505 C110.857407,137.006577 108.782616,137.153625 106.398102,137.125610"
          />
          <path
            fill="#761432"
            opacity="1.000000"
            stroke="none"
            d="M55.188911,140.123947 C60.899776,129.527512 66.875351,119.175400 73.167747,108.274422 C75.307533,110.096855 76.510864,111.121719 77.858253,112.430099 C77.798576,113.290451 77.594849,113.867294 77.191803,114.678024 C75.006378,117.645844 73.020256,120.379776 70.951477,123.439713 C68.653008,127.625031 66.437180,131.484344 64.092934,135.674286 C62.502834,137.563538 61.041153,139.122162 59.282852,140.816772 C57.808693,140.757919 56.631161,140.563095 55.188911,140.123947"
          />
          <path
            fill="#781835"
            opacity="1.000000"
            stroke="none"
            d="M83.175903,104.334808 C81.319031,104.672768 79.462158,105.010727 77.605286,105.348686 C77.329010,104.969719 77.052742,104.590752 76.776466,104.211784 C85.015350,92.258766 93.254234,80.305756 101.493118,68.352737 C101.723206,68.431084 101.953293,68.509438 102.183380,68.587784 C101.088394,73.231628 99.993416,77.875473 98.402908,82.981216 C92.996902,90.407005 88.086403,97.370911 83.175903,104.334808"
          />
        </svg>
      </Link>
    </div>
  );
}
